<template>
  <v-card :flat="flat" :color="transparent ? 'transparent' : ''" :dark="dark">
    <h5>
      Powered by
      <a href="https://www.qwips.no" style="color: inherit;"><b>Qwips</b></a> <br>
    </h5>
    <h6>Equipment service made simple.</h6>
    <br>
    <v-icon size="18" class="mr-1">mdi-email</v-icon> Sales@qwips.no <br>
    <v-icon size="18" class="mr-1">mdi-phone</v-icon> +47 22 22 44 00 <br>
    <v-icon size="18" class="mr-1">mdi-link-variant</v-icon><a href="https://www.qwips.no">www.qwips.no</a> <br>
  </v-card>
</template>


<script>
export default {
  name: "DeveloperContactCard",
  props: {
    dark: Boolean,
    transparent: Boolean,
    flat: Boolean,
  },
  components: {},

  data() {
    return {};
  },

  methods: {},

  computed: {},

  watch: {},
};
</script>


<style lang='scss' scoped></style>